import { singleton } from 'tsyringe';
import { OWGames } from '../../odk-ts';

type RunningGameInfo = overwolf.games.RunningGameInfo;

// -----------------------------------------------------------------------------
@singleton()
export class OWGamesWrapper {
  // ---------------------------------------------------------------------------
  public async getRunningGameInfo(): Promise<RunningGameInfo> {
    return OWGames.getRunningGameInfo();
  }

  // ---------------------------------------------------------------------------
  public async getGameDBInfo(gameId: number): Promise<any> {
    return OWGames.getGameDBInfo(gameId);
  }
}
